import * as React from 'react';

import { useDailyRentOtaConversionExperimentEnabled } from '../../../../../../shared/common/utils/experiments/dailyrentOtaConversion';
import { getTermValue } from '../../../../../JsonQuery';
import { OnlineBooking } from '../../../components/advancedFilters/OnlineBooking';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const OnlineBookingContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const onlineBooking = getTermValue('online_booking')(jsonQuery);
  const isDailyRentOtaConversionExperimentEnabled = useDailyRentOtaConversionExperimentEnabled();

  const handleChange = React.useCallback(
    (value: boolean | null) => {
      onChange({ action: 'setOnlineBooking', arguments: [value] });
    },
    [onChange],
  );

  if (isDailyRentOtaConversionExperimentEnabled) {
    return null;
  }

  return <OnlineBooking value={onlineBooking} onChange={handleChange} />;
};
